export default "__VITE_ASSET__DujzvO$K__"